import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { LibraryComponentEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class LibraryComponentSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    libraryComponentCreated$() {
        return this.socketService.receiveMessageObserver(LibraryComponentEvents.LIBRARY_COMPONENT_CREATED);
    }

    libraryComponentUpdated$() {
        return this.socketService.receiveMessageObserver(LibraryComponentEvents.LIBRARY_COMPONENT_UPDATED);
    }

    libraryComponentDeleted$() {
        return this.socketService.receiveMessageObserver(LibraryComponentEvents.LIBRARY_COMPONENT_DELETED);
    }
}
